import { PayoutRuleType, useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY as SERVICE_CONFIGS_QUERY_KEY } from './useServiceConfigs.query';

interface PayoutRuleTierPayload {
  processing_tier_id: number;
  payout_rule_type: PayoutRuleType;
}

interface UpdatePayoutRulesPayload {
  tiers: PayoutRuleTierPayload[];
}

export const useUpdatePayoutRulesQuery = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ processingRuleId, payload }: { processingRuleId: string; payload: UpdatePayoutRulesPayload }) =>
      api.patch(API_URL.PROCESSING_RULES_PAYOUT_RULES_BY_ID(processingRuleId), payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [SERVICE_CONFIGS_QUERY_KEY],
        });
      },
    }
  );

  return mutation;
};
